export default __webpack_public_path__ + "6471d7d76b682a09994c6a181ce6fc01.png";